const isObjectCode = `import { isObject } from 'cristatus';

const isObject = isObject({}); //true
`;

export default isObjectCode;
